<!-- Loading -->
<div *ngIf="isLoading" class="space-y-2">
  <div *ngFor="let i of [1,2,3]" 
    class="bg-white dark:bg-surface-900 rounded-lg p-3 border border-surface-200 dark:border-surface-800">
    <p-skeleton width="100%" height="70px"></p-skeleton>
  </div>
</div>

<!-- Empty State -->
<div *ngIf="!isLoading && orders.length === 0" class="text-center py-8">
  <div class="bg-surface-50 dark:bg-surface-800 rounded-lg w-12 h-12 flex items-center justify-center mx-auto mb-2">
    <i class="pi pi-shopping-bag text-xl text-surface-400"></i>
  </div>
  <h3 class="text-sm font-medium text-surface-900 dark:text-surface-50 mb-1">
    Keine Bestellungen
  </h3>
  <p class="text-xs text-surface-500 dark:text-surface-400 mb-3">
    Du hast noch keine Bestellungen aufgegeben
  </p>
  <p-button 
    label="Jetzt einkaufen" 
    icon="pi pi-shopping-cart" 
    routerLink="/dashboard/regio-shop"
    [outlined]="true"
    size="small">
  </p-button>
</div>

<!-- Orders List -->
<div *ngIf="!isLoading && orders.length > 0" class="space-y-2">
  <div *ngFor="let order of orders" 
    (click)="viewOrder(order)"
    class="bg-white dark:bg-surface-900 rounded-lg p-3 border border-surface-200 dark:border-surface-800 hover:border-surface-300 dark:hover:border-surface-700 transition-colors cursor-pointer">
    
    <!-- Header: Shop + Price + Status -->
    <div class="flex items-start gap-2.5 mb-2">
      <img *ngIf="order.business_hub?.avatar" 
        [src]="order.business_hub!.avatar"
        class="w-9 h-9 rounded-md object-cover" />
      <div class="flex-1 min-w-0">
        <h4 class="text-sm font-medium text-surface-900 dark:text-surface-50 truncate">
          {{ order.business_hub?.name || 'Unbekannt' }}
        </h4>
        <p class="text-xs text-surface-500 dark:text-surface-400">
          {{ formatOrderDate(order.createdAt) }} · #{{ order.orderNumber }}
        </p>
      </div>
      <div class="text-right">
        <p class="text-sm font-semibold text-surface-900 dark:text-surface-50 mb-1">
          {{ order.totalPrice | currency:'EUR':'symbol':'1.2-2':'de' }}
        </p>
        <p-chip 
          [label]="getStatusInfo(order.status).label" 
          [styleClass]="'text-[10px] px-2 py-0.5 ' + getStatusInfo(order.status).color">
        </p-chip>
      </div>
    </div>

    <div class="flex items-center gap-4 mb-2 text-xs">
      <!-- Delivery Method -->
      <div class="flex items-center gap-1.5"
        [ngClass]="order.deliveryMethod === 'Click and Collect' ? 'text-blue-600' : 'text-green-600'">
        <i [class]="'pi ' + getDeliveryIcon(order.deliveryMethod)"></i>
        <span class="font-medium">
          {{ order.deliveryMethod === 'Click and Collect' ? 'Abholung' : 'Lieferung' }}
        </span>
      </div>

      <!-- Time Info -->
      <div class="flex items-center gap-1.5 text-surface-600 dark:text-surface-400"
        *ngIf="getDeliveryTime(order)">
        <i class="pi pi-clock"></i>
        <span>{{ getDeliveryTime(order) }}</span>
      </div>
    </div>

    <div class="flex items-center justify-between text-xs">
      <div class="flex items-center gap-3">
        <span class="flex items-center gap-1 text-surface-600 dark:text-surface-400">
          <i class="pi pi-box"></i>
          {{ getTotalItems(order) }} Artikel
        </span>
        
  
      </div>

      <i class="pi pi-chevron-right text-surface-400"></i>
    </div>
  </div>
</div>